<template>
  <div id="modal_popup_reward" class="modal-popup">
    <div class="modal-popup-content">
      <a @click="showModalPopup('modal_popup_reward', false)" class="close-button">
        <img src="@/assets/images/close-button.svg" />
      </a>
      <!-- <div class="d-inline-block container-right"> -->
      <div class="offer-details-wrapper">
        <div class="addRewardLayout border-box flex-wrap flex-xl-nowrap justify-content-center">
          <div class="container-fluid d-flex flex-column align-items-center">
            <div class="row d-flex flex-column align-items-baseline w-80 ">
              <small class="text-break">{{ $t("cmsLang.gameNameRoLabel") }}</small>
              <input type="text" required minlength="1" v-model="newReward.texts['ro'].title" class="formedituser w-100" />
            </div>
            <div class="row d-flex flex-column align-items-baseline w-80 ">
              <small class="text-break">{{ $t("cmsLang.gameNameEnLabel") }}</small>
              <input type="text" required minlength="1" v-model="newReward.texts['en'].title" class="formedituser w-100" />
            </div>
            <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.gameDescriptionRoLabel") }}</small>
              <textarea required minlength="1" v-model="newReward.texts['ro'].description" class="formedituser w-100" maxlength="1000" />
              <!-- <VueEditor id="editor" v-model="newReward.texts['ro'].description" :editor-toolbar="customToolbar"
                class="formedituser w-100" maxlength="1000" /> -->
            </div>
            <br />
            <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.gameDescriptionEnLabel") }}</small>
              <textarea required minlength="1" v-model="newReward.texts['en'].description" class="formedituser w-100" maxlength="1000" />
              <!-- <VueEditor id="editor" v-model="newReward.texts['en'].description" :editor-toolbar="customToolbar"
                class="formedituser w-100" maxlength="1000" /> -->
            </div>
            <br />
            <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.priceLabel") }}</small>
              <input type="number" v-model="newReward.price" class="formedituser w-100" onwheel="return false;" />
            </div>
            <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.startDateLabel") }}</small>
              <div class=" d-flex flex-row justify-content-between w-80">
                <date-range class="invoices-filter" :noRanges="true" :single="true" :minDateOrder="minDate"
                  :time="newReward.startDate" @close="startDateSelected" />
                
              </div>
            </div>
            <br />
            <!-- <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.imageLabel") }}</small>
              <div class="uploadImageDiv w-100">
                <div @click="$refs.fileInput1.click()">
                  <div v-if="this.previewImage" class="offer-preview-image"
                    :style="{ 'background-image': `url(${previewImage})` }">
                  </div>
                  <div v-else-if="newReward.id > 0" class="offer-preview-image"
                    :style="{ 'background-image': `url(${this.getImagePath() + 'missions/' + newReward.id + '.png'})` }">
                  </div>
                  <img v-else class="offer-preview-image" :src="require('@/assets/images/cms-mkt/offer_0.svg')" />
                </div>
                <br />
                <p v-html="$t('cmsLang.imageInfoLabel')">
                </p>
                <!- <a @click="$refs.fileInput1.click()" class="uploadFile">
                {{ $t("cmsLang.uploadImageLabel") }}</a> 
                <input type="file" @input="uploadFile()" ref="fileInput1" style="display: none"
                  accept=".png, .jpg, .jpeg" />
              </div>
            </div> -->
            <div v-if="this.error " class="row d-flex flex-column align-items-baseline w-80">
              <p class="red">{{ $t('cmsLang.errorMessage_' + error.code) }}</p>
            </div>
            <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.publishLabel") }}</small>
              <div class="row d-flex flex-row align-items-baseline justify-content-between w-80">
                <a @click="submitReward(false)" class="button-all button-blue">
                  {{ $t('cmsLang.saveLabel') }}

                </a>
                <!-- <a @click="showModalPopup('modal_popup_confirm', true)" class="button-all button-red">
                  {{ $t('cmsLang.deleteLabel') }}

                </a> -->
                <a @click="submitReward(true)" class="button-all button-yellow" v-if="isUserAdmin(user)">
                  {{ $t('cmsLang.approveLabel') }}

                </a>
                <a @click="showModalPopup('modal_popup_confirm', true)" class="button-all button-red">
                  {{ $t('cmsLang.deleteLabel') }}

                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <div id="modal_popup_confirm" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_confirm', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <br />
        <p>
          {{ $t("cmsLang.confirmDeleteRewardMessage") }}
        </p>
        <div class="buttons">
          <a href="#" class="yesButton" @click="deleteReward()">
            {{ $t("cmsLang.notificationsChooseOptionYes") }}
          </a>
          <a href="#" class="noButton" @click="showModalPopup('modal_popup_confirm', false)">
            {{ $t("cmsLang.notificationsChooseOptionNo") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
// import validator from "@/plugins/fieldValidation";
import DateRange from "@/components/DateRange.vue";
import httpServiceCustomer from "@/http/http-play.js";
import Cookies from "js-cookie";
// import { VueEditor } from "vue2-editor";

export default {
  name: "NewRewardPopup",

  props: {
    user: Object,
    reward: Object,
    image: String,
  },
  components: {
    DateRange,
   // VueEditor
  },
  data() {
    return {
      customToolbar: [
        [{ 'header': [false, 1, 2, 3, 4, 5, 6,] }],
        ["bold", "italic"],
        [{ align: "left" }, { align: "center" }, { align: "right" }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"]
      ],
      newReward: {
        texts: [],
        price: 0,
        stock: 0,
        startDate: [],
        endDate: [],
        image: null,
        type: "general",
      },
      previewImage: null,
      minDate: moment().toDate(),
      error: null,

    };
  },
  methods: {
    submitReward(approve) {
      // validare ??
      // construct reward object
      if (this.newReward.texts['ro'].title === "") {
        this.error = { code: "RI3" };
        return;
      }
      if (this.newReward.texts['ro'].description === "") {
        this.error = { code: "RI5" };
        return;
      }
      if (this.newReward.texts['en'].title === "") {
        this.error = { code: "RI4" };
        return;
      }
      if (this.newReward.texts['en'].description === "") {
        this.error = { code: "RI6" };
        return;
      }
      
      this.showModalPopup("modal_popup_loading_cms", true);

      let submitReward = {
        id: this.newReward.id,
        texts: [
          {
            type: "R",
            language: "ro",
            title: this.newReward.texts['ro'].title,
            description: this.newReward.texts['ro'].description
          },
          {
            type: "R",
            language: "en",
            title: this.newReward.texts['en'].title,
            description: this.newReward.texts['en'].description
          },
        ],
        // stock: this.newReward.stock,
        price: this.newReward.price,
        // end_date: moment(this.newReward.endDate[0]).format('DD-MM-YYYY'),
        // start_date: moment(this.newReward.startDate[0]).format('DD-MM-YYYY'),
        status: this.newReward.status,
        type: this.newReward.type
      }

      if (this.newReward.endDate.length > 0) {
        submitReward.end_date = moment(this.newReward.endDate[0]).format('DD-MM-YYYY');
      }
      if (this.newReward.startDate.length > 0) {
        submitReward.start_date = moment(this.newReward.startDate[0]).format('DD-MM-YYYY');
      }

      if (approve) {
        this.approveReward(submitReward);
      } else if (this.newReward.id > 0) {
        this.updateReward(submitReward);
      } else {
        this.addNewReward(submitReward);
      }
    },
    approveReward(reward) {
      httpServiceCustomer.customerService
        .approveReward(
          reward,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.$emit("showinfo", "rewardApprovedSuccess", null);
            this.$emit("updatelist");

          } else {
            this.error =  error.response.data ;
            this.$emit("showinfo", "rewardApprovedSuccess", this.error);
          }
          this.showModalPopup("modal_popup_loading_cms", false);

        })
        .catch((error) => {
          if (error.response) {
            this.error =  error.response.data ;
          } else {
            this.error = ["undefined"];
          }
          this.$emit("showinfo", "rewardApprovedSuccess", this.error);
          this.showModalPopup("modal_popup_loading_cms", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    updateReward(reward) {
      httpServiceCustomer.customerService
        .updateReward(
          reward,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.$emit("showinfo", "rewardModifiedSuccess", null);
            this.$emit("updatelist");

          } else {
            this.error = { description: response.status };
          }
          this.showModalPopup("modal_popup_loading_cms", false);
          // this.showModalPopup("modal_popup_info", true);
        })
        .catch((error) => {
          if (error.response) {
            this.error = { description: error.response.status };
          } else {
            this.error = { description: "undefined" };
          }
          // this.showModalPopup("modal_popup_loading_cms", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    addNewReward(reward) {
      httpServiceCustomer.customerService
        .addNewReward(
          reward,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.$emit("showinfo", "rewardAddSuccess", null);
            this.$emit("updatelist");

          } else {
            this.error = { description: response.status };
          }
          this.showModalPopup("modal_popup_loading_cms", false);
          // this.showModalPopup("modal_popup_info", true);
        })
        .catch((error) => {
          if (error.response) {
            this.error = { description: error.response.status };
          } else {
            this.error = { description: "undefined" };
          }
          this.showModalPopup("modal_popup_loading_cms", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    deleteReward() {
      this.successMessage = "";
      this.error = null;
      this.showModalPopup("modal_popup_confirm", false);
      this.showModalPopup("modal_popup_loading_cms", true);

      httpServiceCustomer.customerService
        .deleteReward(
          this.newReward.id,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.$emit("showinfo", "rewardDeleteSuccess", null);
            this.$emit("updatelist");
          } else {
            this.error = { description: response.status };
          }
          this.showModalPopup("modal_popup_loading_cms", false);
        })
        .catch((error) => {
          if (error.response) {
            this.error = { description: error.response.status };
          } else {
            this.error = { description: "undefined" };
          }
          this.showModalPopup("modal_popup_loading_cms", false);
        });
    },
    uploadFile() {
      let input = this.$refs.fileInput1;
      let file = input.files;
      if (file && file[0]) {
        let readerReward = new FileReader();
        readerReward.onload = (e) => {
          if (!e) {
            this.newReward.image = btoa(readerReward.content);
          } else {
            this.newReward.image = btoa(e.target.result);
          }
        };
        // reader.readAsDataURL(file[0]);
        if (readerReward.readAsBinaryString) {
          readerReward.readAsBinaryString(file[0]);
        } else {
          alert("This browser does not support HTML5.");
        }

        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        if (reader.readAsBinaryString) {
        } else {
          alert("This browser does not support HTML5.");
        }
        // this.$emit("input", file[0]);
      }
    },
    startDateSelected(value) {
      this.newReward.startDate = value;
    },
    // endDateSelected(value) {
    //   this.newReward.endDate = value;
    // },
  },
  computed: {
    isRewardMultiben() {
      if (this.newReward && this.newReward.type) {
        switch (this.newReward.type) {
          case "unique":
            return true;
          default:
            return false;
        }
      }
      return false;
    },

  },
  watch: {
    reward: function () {
      this.error = null;

      if (this.reward.id) {
        this.newReward.type = this.reward.type;
        this.newReward.id = this.reward.id;
      } else {
        this.newReward.type = "";
        this.newReward.id = 0;
      }
      if (this.newReward.id > 0) {

        this.newReward.endDate = this.reward.end_date ? [moment(this.reward.end_date, 'DD-MM-YYYY')] : [moment()]; 
        this.newReward.startDate = this.reward.start_date ? [moment(this.reward.start_date, 'DD-MM-YYYY')] : [moment()]; 
        this.newReward.price = this.reward.price;
        this.newReward.stock = this.reward.stock;
        this.newReward.status = this.reward.status;

        if (this.reward.texts) {
          this.reward.texts.forEach((x) => {
            this.newReward.texts[x.language] = {
              title: x.title,
              description: x.description
            }
          })
        };
      } else {
        this.newReward = {
          texts: [],
          price: 0,
          stock: 0,
          startDate: [moment()],
          endDate: [moment()],
          image: null,
        };
        this.newReward.texts['ro'] = { title: "", description: "" };
        this.newReward.texts['en'] = { title: "", description: "" };
      }
    },
    isAmount: function (val) {
      if (val) {
        this.newReward.type = 'amount';
      } else {
        this.newReward.type = 'counter';
      }
    },
  },
  created() {
    this.newReward.type = "";
    this.newReward.texts['ro'] = { title: "", description: "" };
    this.newReward.texts['en'] = { title: "", description: "" };
  },
};
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
<style scoped>

.position {
  position: relative;
  left: 227px;
}


.contact-details-wrapper {
  justify-content: space-evenly;
  color: #2D3736;
}

.close-button {
  right: 30px;
  top: 15px;
}

.offer-details-wrapper {
  border-radius: 48px;
  background: #E5E5E5;
  overflow-y: auto;
  height: calc(100vh - 170px) !important;
}

small {
  font-family: "Krona One";
  font-weight: 400;
  font-size: 18px;
  text-transform: uppercase;
}

.w-80 {
  width: 80%;
}


.multiselect {
  border: 1px solid #d8d8d8;
  background: #f1f1f1 !important;
  height: 40px !important;
  /* border-radius: 20px; */

}

.multiselect__input {
  font-size: 15px !important;
  /* border-radius: 20px !important; */
}

.multiselect__tags {
  border-radius: 40px !important;
  padding: 8px -30px 0 8px !important;
}
</style>
